<template>
  <div>
<!--    <span>在下面虚线框内签字</span>-->
    <div id="watermarkId">
      <vue-esign
          ref="esign"
          style="border: 1px dashed #ddd;"
          :width="canWidth"
          :height="canHeight"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor="bgColor"
          :isClearBgColor="isClearBgColor"
          :isCrop="isCrop"
      >
      </vue-esign>
    </div>

    <div style="margin: 12px auto;text-align: center">
      <a-button @click="handleGenerate" type="primary" style="margin-right: 12px">确定</a-button>
      <a-button @click="handleReset" type="normal">清空</a-button>
    </div>
  </div>
</template>

<script>
import watermark from 'watermark-dom'

// 解构设备的宽度, 和 高度
export default {
  data () {
    return {
      canWidth: 800, // 画布宽度--是不会超出父元素的宽度的--设置也不行
      canHeight: 300,
      lineWidth: 6, // 画笔粗细
      lineColor: '#000000', // 画笔颜色
      bgColor: '#F2F2F2', // 画布背景
      isCrop: false, // 是否裁剪
      isClearBgColor: false, // 是否清空背景色
      resultImg: '' // 生成签名图片-base64
    }
  },
  mounted() {
    const watermarkText = '在此处签名'
    const options = {
      watermark_txt: watermarkText, // 水印的内容
      watermark_color: '#ccc', // 水印字体颜色
      watermark_fontsize: '36px', // 水印字体大小
      watermark_x: 0, // 水印起始位置x轴坐标
      watermark_y: 0, // 水印起始位置Y轴坐标
      watermark_rows: 1, // 水印行数
      watermark_cols: 1, // 水印列数
      watermark_alpha: 0.6, // 水印透明度，要求设置在大于等于0.005
      watermark_angle: 0, // 水印倾斜度数
      watermark_width: 200, // 水印宽度
      watermark_height: 60, // 水印长度
      watermark_parent_node: 'watermarkId' // 水印插件挂载的父元素element,不输入则默认挂在body上
    }
    watermark.load(options)
  },
  methods: {
    handleReset () {
      this.$refs['esign'].reset()
      this.resultImg = null
    },
    handleGenerate () {
      // 去除水印
      watermark.remove()

      this.$refs['esign'].generate().then(res => {
        this.resultImg = res // 得到了签字生成的base64图片
        this.$emit('getSign', this.resultImg)
      }).catch(err => {
        //  没有签名，点击生成图片时调用
        console.log(err)
        this.$message.error('请先在签字区签字')
      })
    },

    // 附：base64转化成图片
    base64ImgtoFile (dataurl, fileName = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${fileName}.${suffix}`, {type: mime})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/infocollect/components/PersonSign.vue